import { createApp } from 'vue'
import App from './App.vue'
import i18n from './i18n'
import router from './router'
import { createStore } from 'vuex'

import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'

const store = createStore({
    state() {
        return {
            metadata: {},
            answers: {},
            comments: {},
            summary: {},
            navState: [],
            benchmark: [],
            calculatedSummaryData: {},
            count: 0,
            answerFile: {}
        }
    },
    mutations: {
        updateVersionAnswers(state){
            Object.entries(state.answers).forEach(([key, value]) => {
                state.answerFile[key] = value
              });
        },
        addAnswers(state) {
            let fileInput = state.answerFile;
            state.answers = {"comments":{}};
            state.answers['lastChangeDate'] = fileInput['lastChangeDate']

            this.state.metadata.questionnaire.forEach(element => {
                let areAllAnswered = 1;
                element.questions.forEach(q => {
                    if (fileInput[q.id] === undefined && fileInput[q.alt_id] === undefined) {
                        areAllAnswered = 0;
                    } else if (fileInput[q.alt_id] !== undefined) {
                        state.answers[q.id] = fileInput[q.alt_id]
                    }
                    else {
                        state.answers[q.id] = fileInput[q.id]
                        if (fileInput.comments !== undefined && fileInput.comments[q.id] !== undefined) state.answers.comments[q.id] = fileInput.comments[q.id]
                    }
                })
                this.state.navState[element.category] = areAllAnswered;
            });
            // console.log(state.answers)
        },
        addSummary(state, payload) {
            state.summary = payload
        },
        addMetadata(state, payload) {
            this.state.count = 0;
            state.metadata = JSON.parse(JSON.stringify(payload))
            state.metadata.questionnaire.forEach(element => {
                this.state.count += element.questions.length
            })
        },
        addDate(state, payload) {
            //state.calculatedSummaryData['lastChangeDate'] = payload
            state.answers['lastChangeDate'] = payload
        },
    },
})

createApp(App).use(i18n).use(router).use(store).mount('#app')
